import HTTP from '../lib/http';
const { isProd } = require('../lib/env');

// 获取商品详情
export function getProductDeatil(productId: string, promo: boolean = true, groupBuy: boolean = false) {
    return HTTP.get(`/api/v1/products/${productId}`, {
        params: { promo, groupBuy }
    });
}

// 获取商品的商家及品牌信息
export function getProductRelated(productId: string) {
    return HTTP.get(`/api/v1/products/${productId}/related`);
}

// 获取相似商品
export function getSimilarProduct(productId: string) {
    return HTTP.get(`/api/v2/products/${productId}/similar/context/PRODUCT_DETAILS`, {
        headers: {
            "Content-Type": "application/x-protobuf-json"
        },
        data: {}
    })
}

// 获取购物袋商家列表
export function getCartMerchantList() {
    return HTTP.get('/api/v2/shoppingcart/cart-info', {
        headers: {
            "Content-Type": "application/x-protobuf-json"
        },
        data: {}
    })
}

// 获取购物袋指定商家详情商家
export function getCartMerchantDetail(merchantId: string, params?: any) {
    return HTTP.get('/api/v2/shoppingcart', {
        params: {
            target: merchantId,
            ca: true,
            ...params
        }
    })
}

interface chooseProductParam {
    groupId: string,
    skuId: string,
    excludedFromOrder: boolean
}

// 购物袋-选择/取消选择商品
export function chooseProduct(param: chooseProductParam) {
    return HTTP.post(`/api/v2/shoppingcart/groups/${param?.groupId}/items/${param?.skuId}`, {
        excludedFromOrder: param?.excludedFromOrder
    })
}

interface changeProductQuantityParam {
    groupId: string,
    skuId: string,
    quantity: number
}
// 加减购物袋内商品数量
export function changeProductQuantity(param: changeProductQuantityParam) {
    return HTTP.post(`/api/v2/shoppingcart/groups/${param?.groupId}/items/${param?.skuId}`, {
        quantity: param?.quantity
    })
}

interface changeShippingMethodParam {
    groupId: string,
    shippingMethod: string
}
// 修改快递方式
export function changeShippingMethod(param: changeShippingMethodParam) {
    return HTTP.post(`/api/v2/shoppingcart/groups/${param?.groupId}`, {
        shippingMethod: param?.shippingMethod
    })
}

interface applyCreditsParam {
    groupId: string,
    applyCents: number
}
// 应用积分
export function applyCredits(param: applyCreditsParam) {
    return HTTP.post(`/api/v2/shoppingcart/groups/${param?.groupId}/loyalty-points`, {
        applyCents: param?.applyCents
    })
}

// 取消积分
export function deleteCredits(groupId: string) {
    return HTTP.delete(`/api/v2/shoppingcart/groups/${groupId}/loyalty-points`);
}

interface selectAllProductParam {
    groupId: string,
    excludedFromOrder: boolean
}
// 全选商品
export function selectAllProduct(param: selectAllProductParam) {
    return HTTP.post(`/api/v2/shoppingcart/groups/${param?.groupId}/items/_all`, {
        excludedFromOrder: param?.excludedFromOrder
    });
}

interface changePayMethodParam {
    groupId: string,
    paymentMethod: string,
    paymentInstallment?: string
}
// 选择支付方式
export function changePayMethod(param: changePayMethodParam) {
    return HTTP.post(`/api/v2/shoppingcart/groups/${param?.groupId}`, {
        paymentMethod: param?.paymentMethod,
        paymentInstallment: param?.paymentInstallment
    });
}

// 获取地址列表
export function getAddressBook() {
    return HTTP.get('/api/v2/profile/addressbook');
}

// 选择当前地址
export function selectAddress(groupId: string, shippingAddressId: string) {
    return HTTP.post(`/api/v2/shoppingcart/groups/${groupId}`, { shippingAddressId });
}

// 立即购买 切换地址
export function expressSelectAddress(groupId: string, shippingAddressId: string) {
    return HTTP.post(`/api/v1/express-buy/details/${groupId}`, { shippingAddressId });
}

// 立即购买 修改
export function expressChange(groupId: string, params: object) {
    return HTTP.post(`/api/v1/express-buy/details/${groupId}`, params);
}

// 修改支付人信息
export function editPayerForGroup(groupId: string, data: any) {
    return HTTP.post(`/api/v2/shoppingcart/groups/${groupId}`, data);
}

// 修改默认地址
export function changeDefaultAddress(id: string, data: any) {
    return HTTP.post(`/api/v1/profile/addressbook/${id}`, data);
}

// 删除地址
export function delAddress(id: string) {
    return HTTP.delete(`/api/v1/profile/addressbook/${id}`);
}

// 新增地址
export function addAddress(data: any) {
    return HTTP.post('/api/v2/profile/addressbook', data);
}

// 编辑地址
export function editAddress(id: string, data: any) {
    return HTTP.post(`/api/v1/profile/addressbook/${id}`, data);
}

// 上传图片
export function uploadImg(data: any) {
    return HTTP.post('/api/v2/profile/photo-ids', data);
}

// 发送短信
export function sendSms(data: any) {
    return HTTP.post('/api/v2/signin/sms', data);
}

// 验证手机
export function verification(data: any) {
    return HTTP.post('/api/v2/signin/sms/verification', data);
}

// 加入购物袋
export function addShoppingCart(data: any) {
    return HTTP.post('/api/v2/shoppingcart', data);
}

// 立即购买
export function expressBuy(data: any) {
    return HTTP.post('/api/v1/express-buy/sku', data)
}

// 预下单-购物袋检查
export function preOrderCartCheck(groupId: string) {
    return HTTP.get(`/api/v2/shoppingcart/groups/${groupId}/preordercheck`, {
        params: {
            step: 0
        }
    });
}

// 预下单-结算页检查
export function preOrderCheck(groupId: string) {
    return HTTP.get(`/api/v2/shoppingcart/groups/${groupId}/preordercheck`, {
        params: {
            step: 1
        }
    });
}

// 立即购买 preOrderCheck 
export function expressPreOrderCheck(groupId: string) {
    return HTTP.get(`/api/v1/express-buy/preordercheck/${groupId}`);
}

// 下单
export function order(data: any) {
    return HTTP.post('/api/v1/orders', data);
}

// 获取weixin config参数
export function getWxConfigParam() {
    return HTTP.get(`/api/v1/wechat-jsticket?url=${encodeURIComponent(window.location.href.split('#')[0])}`);
}

// 获取支付
export function getPayerList() {
    return HTTP.get('/api/v1/profile/payer-identities');
}

// 选择支付人
export function selectPayer(id: string, data: any) {
    return HTTP.post(`/api/v1/profile/payer-identities/${id}`, data);
}

// 删除支付人
export function deletePayer(id: string) {
    return HTTP.delete(`/api/v1/profile/payer-identities/${id}`);
}

// 新增支付人
export function addPayer(data: any) {
    return HTTP.post('/api/v1/profile/payer-identities', data);
}

// 修改支付人信息
export function editPayer(id: string, data: any) {
    return HTTP.post(`/api/v1/profile/payer-identities/${id}`, data);
}

// 获取openId
export function getOpenId(code: string) {
    return HTTP.get(`/api/v1/wechat/openId?code=${code}`);
}

// 获取订单支付状态
export function getOrderPayInfo(orderId: string) {
    return HTTP.get(`/api/v1/orders/${orderId}/completion`);
}

// 获取商家运费问答信息
export function getMerchantQA(merchantId: string) {
    return HTTP.get(`/api/v1/merchants/${merchantId}/domesticshipping`);
}

// 获取官网详情翻译
export function getTranslate(productId: string) {
    return HTTP.get(`https://5thave-prod.bieyangapp.com/api/v1/translate/product/${productId}`);
}

// 获取购物袋信息
export function getCartInfo() {
    return HTTP.get('/api/v2/shoppingcart/cart-meta-info', {
        headers: {
            "Content-Type": "application/x-protobuf-json"
        },
        data: {}
    });
}

// 获取订单详情
export function getOrderDetail(orderId: string) {
    return HTTP.get(`/api/v1/orders/${orderId}`, {
        params: {
            pv: true,
        },
    })
}

// 获取新人大礼包配置
export function getNewUserCoupon() {
    return HTTP.get('/api/v1/appconfig')
}

// 获取地区列表
export function getAreaList(code?: string) {
    if (code) return HTTP.get(`/api/v1/basic-data/world-areas/${code}?scenario=SHIPPING_ADDRESS`);
    return HTTP.get('/api/v1/basic-data/world-areas?scenario=SHIPPING_ADDRESS');
}

// 微信登录
export function wxLogin(data: any) {
    return HTTP.post('/api/v1/wechat-login/login/web', data);
}

// 购物袋空态内推荐商品
export function discover(f: number = 0, t: number = 10) {
    return HTTP.get('/api/v2/discover', {
        params: {
            pr: 'f0-',
            dr: '0-100',
            f,
            t
        }
    });
}

// 绑定手机号发送验证短信
export function sendBindPhoneSms(data: any) {
    return HTTP.post('/api/v1/wechat-login/sms/bind', data);
}

// 绑定手机号
export function bindPhone(data: any) {
    return HTTP.post('/api/v1/wechat-login/bind/phone', data);
}

// BC超额 获取订单信息
export function getResell(orderId: string) {
    return HTTP.get(`/api/v1/customs-resell/${orderId}`)
}

// BC超额更换支付人 生成新订单
export function customsResell(data: Object) {
    return HTTP.post(`/api/v1/customs-resell`, data)
}

// 获取laas商家的的订单详情-无需登录
export function getThirdOrderDetail(orderId: string) {
    return HTTP.get(`/api/v1/orders/${orderId}/pay-on-behalf`, {
        params: {
            pv: true,
        },
    })
}

// 为后端生成的非支付宝支付的订单更新wechatPay： 插入openId
export function updateThirdWechatPay(data: Object) {
    // /api/v1/_internal/order-admin/orders/update-bc-sell
    return HTTP.post(`/api/v1/_internal/order-admin/orders/update-bc-sell`, data)
}

// 删除购物袋内商品
export function deleteProduct(groupId: string, skuId: string) {
    return HTTP.delete(`/api/v2/shoppingcart/groups/${groupId}/items/${skuId}`);
}

// 获取订单列表
export function getOrderList(params: Object) {
    return HTTP.get('/api/v1/orders', { params: params })
}

// 获取商家列表
export function getMerchants() {
    return HTTP.get('/api/v2/merchants')
}

// 物流信息
export function getShipping(orderId: string, groupId: string, itemId: string) {
    return HTTP.get(
        `/api/v1/orders/${orderId}/groups/${groupId}/items/${itemId}/shipping`
    )
}

// 获取商家列表
export function getMerchantsList() {
    return HTTP.get('/api/v2/merchants');
}

// 获取品牌列表
export function getBrandList(n: string) {
    return HTTP.get(`/api/v1/brands?f=0&t=10000&np=${n}`);
}

// 获取亲友付订单
export function getAddonOrder(orderId: string) {
    return HTTP.get(`/api/v1/orders/${orderId}/payment/friend-pay`);
}

// 支付亲友付订单
export function payAddonOrder(orderId: string, params: any) {
    return HTTP.post(`/api/v1/orders/${orderId}/payment/friend-pay`, params);
}

interface Identity {
    firstName: string,
    lastName: string,
    idNumber: string
}

// 修改亲友付订单支付人信息
export function updateAddonPayer(orderId: string, params: Identity) {
    return HTTP.post(`/api/v1/orders/${orderId}/payment/friend-pay/checkpayeridentity`, params);
}// 获取商品列表
export function getProductComment(productId: string, size = 10, from = 0, sort = 'posted_at', tag = '') {
    return HTTP.get(`/api/v1/product-comment/products/${productId}/comments`, {
        params: {
            f: from,
            t: size,
            s: sort,
            tag
        }
    });
}

// 点赞商品评论
export function likeProductComment(productId: string, commentId: string) {
    return HTTP.post(`/api/v1/product-comment/products/${productId}/comments/${commentId}/likes`);
}

// 取消点赞商品评论
export function unlikeProductComment(productId: string, commentId: string) {
    return HTTP.delete(`/api/v1/product-comment/products/${productId}/comments/${commentId}/likes`);
}

// 领取代金券
export function getCoupon(link: any) {
    return HTTP.post(link)
}

// 获取首页铺底商品
export function getHomeBottomProducts(data: object) {
    return HTTP.post(`/api/v2/recommend/product/bottom`, data)
}

// 获取是否展示popup
export function getUnreadPopup(utm_source?: string) {
    return HTTP.get(utm_source ? `/api/v1/popup/unread?channel_source=${utm_source}` : `/api/v1/popup/unread`)
}

// 展示并点击了popup
// let data = {
//     id: homePopUp.id,
//     popupType: homePopUp.popupType
//   }
export function postReadPopup(data: object) {
    return HTTP.post(`/api/v1/popup/read`, data);
}

/**
 * 
 * @param data 
 * {
 *  "uniqueId":"shihuo-uniquie",
 *  "accessToken":"shihuo-accessttokn",
 *  "acqChannel":"shihuo"
 * }
 */
export function postShiHuoLogin(data: object) {
    return HTTP.post(`/api/v1/shihuo/login`, data)
}

/**
 * 通过fifthave，获取请求识货接口的参数。
 */
export function getShiHuoSign(act: string) {
    return HTTP.get(`/api/v1/shihuo/login/sign?act=${act}`)
}

export function cancelOrder(id: string) {
    return HTTP.post(`/api/v1/orders/${id}/cancel2/_apply`)
}

export function confirmCancelOrder(id: any, data: any) {
    return HTTP.post(`/api/v1/orders/${id}/cancel2/_confirm`, data)
}

// 根据商品获取本人优惠券信息
export function getCouponByProduct(productId: string) {
    return HTTP.get(`/api/v1/claim/popup/SUITPRODUCT/${productId}`);
}

// 领取优惠券
export function receiveCoupon(couponId: string, couponType: string) {
    return HTTP.post(`/api/v1/claim/${couponType}/${couponId}`);
}

// 获取所有类目
export function getCatrgroies() {
    return HTTP.get(`/api/v2/productcategories`)
}

// 获取类目商品
export function getCategoryProducts(cids: string) {
    return HTTP.get(`/api/v2/discover?cids=${cids}&t=15`)
}

// 新人大礼包
export function getGiftAmount() {
    return HTTP.get(`/api/v1/wechat/miniprogram/gift-amount`)
}



// 获取晒单列表
export function getHaulComment(f: number = 0, size: number = 10, category: string = '0') {
    return HTTP.get(`/api/v2/product_comment/haul?category=${category}&delimiter=${f}&size=${size}`)
}

// 类目页筛选discover
export function categoryDiscover(q: string) {
    return HTTP.post('/api/v3/discover', {
        q: q
    }, {
        headers: {
            "Content-Type": "application/x-protobuf-json"
        },
    });
}

export function getSizeInfo(productId: string) {
    return HTTP.get(
      `/api/v1/sizecharts/products/${productId}`
    );
}